<template>
  <div class="menu">
    <div class="menu__header">
      <router-link :to="{ name: homeRoute }" class="menu__header-link">
        <img src="@/assets/img/menu-logo.svg" alt="Logo">
      </router-link>
      <button class="menu__close" @click="onCloseMenu"></button>
    </div>
    <div class="menu__wrapper">
      <nav class="menu__nav">
        <template v-for="part in real_menu">
          <div
            v-if="checkRoles(user.groups, part.roles)"
            :key="part.title"
            class="menu__part"
          >
            <div class="menu__title">{{ part.title }}</div>
            <div class="menu__list" :key="temp_key">
              <router-link
                v-for="item in part.list"
                :key="item.label"
                v-show="checkRoles(user.groups, item.roles)"
                :to="{ name: item.name }"
                class="menu__item"
                active-class="menu__item--active"
                :class="{ 'menu__item--counted': item.count }"
                @click.native="onCloseMenu"
              >
                {{ item.label }} <span v-if="item.count" class="menu__count">{{ item.count }}</span>
              </router-link>
            </div>
          </div>
        </template>
      </nav>
    </div>
    <div class="menu__bottom">
      <div class="menu__user">
        <div class="menu__ava-wrapper">
          <div class="menu__ava">
            <img :src="userAvatar" alt="Avatar">
          </div>
          <img v-if="user.is_2fa_enabled" class="menu__2fa" src="@/assets/img/2fa-enabled-icon.svg" alt="">
          <img v-else class="menu__2fa" src="@/assets/img/2fa-not-enabled-icon.svg" alt="">
        </div>
        <div v-if="user" class="menu__username">{{ userName }}</div>
      </div>
      <button @click="onLogout" class="menu__logout">
        <img src="@/assets/img/logout.svg" alt="">
      </button>
    </div>
  </div>
</template>

<script>
import { getNavStats } from '@/http'
import { clearAuthTokens } from 'axios-jwt'
import { getIndexPageMobile } from '@/router/personalCabinet'

export default {
  name: 'AppMenu',
  props: {
    user: Object,
  },
  data() {
    return {
      filter: '',
      real_menu: [
        {
          title: 'Personal cabinet',
          list: [
            { label: 'Overview', name: 'personal-cabinet-overview', roles: ['employee_self_service'] },
            { label: 'Requests', name: 'personal-cabinet-requests', roles: ['employee_self_service'] },
            { label: 'Profile', name: 'personal-cabinet-profile', roles: ['employee_self_service'] },
            { label: 'Payslips', name: 'personal-cabinet-payslips', roles: ['employee_self_service'] },
            { label: 'Loans', name: 'personal-cabinet-loans', roles: ['employee_self_service'] },
            { label: 'Advances', name: 'personal-cabinet-advances', roles: ['employee_self_service'] },
            { label: 'HESLB', name: 'personal-cabinet-heslb', roles: ['employee_self_service'] },
            { label: 'Leave', name: 'personal-cabinet-leave', roles: ['employee_self_service'] },
            { label: 'Medical Reports', name: 'personal-cabinet-medical-reports', roles: ['employee_self_service'] },
            { label: 'Misconduct', name: 'personal-cabinet-misconduct', roles: ['employee_self_service'] },
          ],
          roles: ['employee_self_service'],
        },
        {
          title: 'Transfers',
          list: [
            { label: 'Fuel receipts', name: 'transfers-fuel-receipts', roles: ['general_manager', 'driver'] },
            // { label: 'Trips', name: 'transfers-trips', roles: ['general_manager', 'driver'] },
          ],
          roles: ['general_manager', 'driver'],
        },
        {
          title: 'Finance',
          list: [{ label: 'Payments', name: 'finance-payments', roles: ['general_manager', 'operations_manager', 'operations_supervisor'] }],
          roles: ['general_manager', 'operations_manager', 'operations_supervisor'],
        },
        {
          title: 'Clients',
          list: [{ label: 'Authorization forms', name: 'authorization-forms', roles: ['general_manager', 'operations_supervisor'] }],
          roles: ['general_manager', 'operations_supervisor'],
        },
        {
          title: 'Hotel management',
          list: [{ label: 'POS transactions', name: 'pos-transactions', roles: ['general_manager', 'hotel_reception', 'hotel_reservations'] }],
          roles: ['general_manager', 'hotel_reservations', 'hotel_reception'],
        },
      ],
      nav_stats: {},
      temp_key: 1
    }
  },
  computed: {
    homeRoute() {
      return getIndexPageMobile(this.user?.groups) || 'base'
    },
    userName() {
      return this.user.employee?.display_name || this.user.display_name || this.user.full_name || [this.user.first_name, this.user.last_name].filter(Boolean).join(' ')
    },
    userAvatar() {
      if (this.user?.crop_url) return this.user.crop_url
      if (this.user?.crop?.crop_url) return this.user.crop.crop_url
      return require('@/assets/img/temp/avatar-slug.jpg')
    },
    hasWorkMenu() {
      const workRoles = this.real_menu
        .filter(menu => menu.title !== 'Personal cabinet')
        .reduce((roles, menu) => [...roles, ...menu.roles], [])
      return this.checkRoles(this.user.groups, workRoles)
    },
  },
  created() {
    if (!this.hasWorkMenu) return
    getNavStats().then(res => {
      this.real_menu.forEach(menu_item => {
        for (const key in res.data) {
          const temp_obj = menu_item.list.find(item => item.name === key)
          if (temp_obj) temp_obj.count = res.data[key]
        }
      })
      this.temp_key = 2
    })
  },
  methods: {
    onCloseMenu() {
      this.$emit('closeMenu')
    },
    checkRoles(user_roles, menu_roles) {
      let showMenu = false
      if (!user_roles.length || !menu_roles.length) return true
      user_roles.forEach(role => {
        showMenu ||= menu_roles.some(menu_role => menu_role === role.code)
      })
      return showMenu
    },
    onLogout() {
      clearAuthTokens()
      localStorage.clear()
      this.$router.push({ name: 'login' })
    },
  }
}
</script>

<style lang="sass" scoped>
.menu
  position: fixed
  top: 0
  right: 0
  width: 100%
  height: 100dvh
  z-index: 100
  padding-top: 30px
  transform: translateX(100%)
  background-color: #404040
  transition: transform 0.4s

  &:before
    content: ''
    position: absolute
    top: 0
    left: -100%
    width: 100%
    height: 100%
    background-color: rgba(0, 0, 0, 0.7)
    opacity: 0
    transition: opacity 0.4s
    pointer-events: none

.menu--show
  transform: translateX(0)

  &:before
    opacity: 1

.menu__header
  display: flex
  align-items: flex-start
  justify-content: space-between
  margin-bottom: 50px
  padding: 0 30px 0 45px

.menu__header-link
  flex-shrink: 0
  display: flex

.menu__close
  width: 30px
  height: 30px
  background-image: url("~@/assets/img/menu-close.svg")

.menu__wrapper
  height: calc(100% - 174px)
  overflow: hidden auto
  scrollbar-color: $color-theme #404040
  scrollbar-width: thin

  &::-webkit-scrollbar
    width: 4px
    transition: width 0.3s

  &::-webkit-scrollbar-track
    background-color: #404040

  &::-webkit-scrollbar-thumb
    background-color: $color-theme

.menu__nav
  padding: 10px 0

.menu__part
  margin-bottom: 20px

  &:last-child
    margin-bottom: 0

.menu__title
  margin-bottom: 10px
  padding: 0 45px
  color: #8a8a8a
  font-size: 18px
  font-weight: 600
  letter-spacing: 3.2px
  text-transform: uppercase

.menu__list
  display: flex
  flex-direction: column

.menu__item
  padding: 10px 45px 12px
  color: #fff
  font-size: 16px
  font-weight: 500
  transition: background-color 0.3s

  &:hover
    background-color: #515151

.menu__item--active
  background-color: #515151

.menu__item--counted
  display: flex
  align-items: center
  gap: 6px

.menu__count
  display: inline-block
  padding: 3px 5px 1.4px
  border-radius: 9px
  background-color: $color-theme
  color: #fff
  font-size: 10px

.menu__bottom
  position: absolute
  bottom: 0
  left: 0
  display: flex
  align-items: center
  justify-content: space-between
  width: 100%
  height: 82px
  padding: 0 30px 0 45px
  border-top: 1px solid #525252

.menu__user
  display: flex
  align-items: center
  gap: 5px 12px

.menu__ava-wrapper
  position: relative

.menu__ava
  flex-shrink: 0
  width: 36px
  height: 36px
  border-radius: 50%
  overflow: hidden

  > img
    width: 100%
    height: 100%
    object-fit: cover

.menu__2fa
  position: absolute
  bottom: 0
  right: -8px
  width: 15px

.menu__username
  color: #fff
  transition: opacity 0.3s

.menu__logout
  padding: 5px
  line-height: 0
  transition: opacity 0.3s
</style>
